import { render } from "./FatView.vue?vue&type=template&id=bcb14148&scoped=true"
import script from "./FatView.vue?vue&type=script&lang=js"
export * from "./FatView.vue?vue&type=script&lang=js"

import "./FatView.vue?vue&type=style&index=0&id=bcb14148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb14148"]])

export default __exports__